var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationObserver',{ref:"observer",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
var invalid = ref.invalid;
var reset = ref.reset;
return [_c('artisio-modal',{attrs:{"size":"sm","visible":_vm.modal.show,"data":_vm.model,"title":"Group Items","ok-title":_vm.$t('Submit'),"is-loading":_vm.loading,"content-in-form":false,"scrollable":""},on:{"hidden":_vm.onHidden,"hide":_vm.onHide,"ok":function($event){$event.preventDefault();return handleSubmit(_vm.onSubmit)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }